"use client";

import PageAnimatePresence from "@/components/organisms/HOC/pageAnimatePresence";
import { ContextWrapper } from "@/context/state";
import { AnimatePresence } from "framer-motion";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

/**
 * Wrapper component that provides context and animates presence.
 *
 * @component
 * @example
 * return (
 *   <Wrapper>
 *     <YourComponent />
 *   </Wrapper>
 * )
 * @param {object} props - The props for the component.
 * @param {React.ReactNode} props.children - The content to be rendered inside the wrapper.
 * @returns {JSX.Element} The wrapper component with context and animation.
 */
const Wrapper = ({ children }) => {
  const pathname = usePathname();

  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();

    document.addEventListener("contextmenu", handleContextMenu);

    // Cleanup event listener on component unmount
    return () => document.removeEventListener("contextmenu", handleContextMenu);
  }, []);

  return !pathname.startsWith("/admin") ? (
    <ContextWrapper>
      <PageAnimatePresence className={`w-full h-full`}>
        {children}
      </PageAnimatePresence>
    </ContextWrapper>
  ) : (
    children
  );
};

export default Wrapper;
